import React, { ReactNode } from 'react';
import { useReveal } from '../../hooks/useReveal';
interface RevealProps {
  children: ReactNode;
  delay?: number;
  className?: string;
}
export function Reveal({
  children,
  delay = 0,
  className = ''
}: RevealProps) {
  const {
    ref,
    visible
  } = useReveal<HTMLDivElement>();
  return <div ref={ref} data-state={visible ? 'visible' : 'hidden'} className={`reveal ${className}`} style={{
    transitionDelay: visible ? `${delay}ms` : '0ms'
  }} data-id="element-557" data-mp="tgg9zvej80bk">
      {children}
    </div>;
}